export const TESTSQUARE_MENU_ACTIONS = {
  MOVE: 'move',
  ANOMALY_DECISIONS: 'anomalyDecisions',
  CHANGE_SIZE: 'changeSize',
  SET_LOCATION: 'setLocation',
};
